<template>
  <section :class="$style.wrapper">
    <h2 :class="$style.title">💡 送信する日程の種類とは</h2>

    <section>
      <p :class="$style.sectionTitle">直近の開いている時間</p>
      <div :class="$style.text">
        <p>
          自動的に空いている1時間枠を5件提示します。<br />
          最初に提示される枠は、日程提示する自動応答チャットメッセージが発動してから24時間以降の、最初に空いている枠になります。<br />
          自動で提示する時間帯は9時〜22時の間になります。夜間・早朝の時間帯
          (23時〜8時)は提示しません。
          <br />
          空き枠を提示できるのは最大2週間後までです。
        </p>
      </div>
    </section>

    <section>
      <p :class="$style.sectionTitle">平日・土日</p>
      <div :class="$style.text">
        <p>
          平日:<br />
          自動で提示する枠を月〜金に限定します。空き枠を提示できるのは最大5枠・2週間後までです。
          <br />
          土日:<br />
          自動で提示する枠を土日に限定します。空き枠を提示できるのは最大5枠・2週間後までです。
        </p>
      </div>
    </section>

    <section>
      <p :class="$style.sectionTitle">日中・夕方以降・終日</p>
      <div :class="$style.text">
        <p>
          日中:<br />
          自動で提示する時間帯が9時〜18時の間になります。<br />
          夕方以降:<br />
          自動で提示する時間帯が18時〜22時の間になります。<br />
          終日:<br />
          自動で提示する時間帯が9時〜22時の間になります。
        </p>
      </div>
    </section>

    <section>
      <p :class="$style.sectionTitle">枠について</p>
      <div :class="$style.text">
        <p>
          提示される枠は連携しているカレンダーのスケジュール状況に依存します。<br />
          カレンダー側の予定を調整することで、自動で提示される枠をある程度調整することができます。
        </p>
      </div>
    </section>
  </section>
</template>

<script lang="ts" setup></script>

<style lang="scss" module>
.wrapper {
  background-color: $color-surface-secondary;
  border-radius: $border-radius-v2-base;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.title {
  font-size: 16px;
  font-weight: 700;
}

.sectionTitle {
  font-weight: 700;
}

.text {
  margin-top: 4px;
}
</style>
